module.exports = __webpack_public_path__ + "static/media/mac-step5.136f95ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mac-step5.png
// module id = 602
// module chunks = 33